import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import AdminLayout from '../components/AdminLayout'
import ChapterComparison from './components/ChapterComparison'
import GrowthChart from './components/GrowthChart'
import RegionBreakdown from './components/RegionBreakdown'
import LoadingSpinner from '../../../components/LoadingSpinner'

const CLUB_ID = 'a0000000-0000-0000-0000-000000000001'

export default function AdminAnalytics() {
  const [members, setMembers] = useState([])
  const [chapters, setChapters] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      const { data: membersData } = await supabase
        .from('supporters').select('*, chapters(name), subscriptions(*)')
        .eq('club_id', CLUB_ID).eq('role', 'supporter').order('joined_at', { ascending: true })
      const { data: chaptersData } = await supabase
        .from('chapters').select('*').eq('club_id', CLUB_ID)
      setMembers(membersData || [])
      setChapters(chaptersData || [])
      setLoading(false)
    }
    fetchData()
  }, [])

  const handleExportCSV = () => {
    if (!members.length) return
    const today = new Date().toISOString().split('T')[0]
    const rows = [
      ['Membership ID', 'Full Name', 'Gender', 'Region', 'Chapter', 'Join Date', 'Subscription Status'],
      ...members.map(m => {
        const activeSub = (m.subscriptions || []).find(
          s => s.status === 'active' && new Date(s.valid_until) >= new Date()
        )
        return [
          m.membership_id || '',
          m.full_name || '',
          m.gender || '',
          m.region || '',
          m.chapters?.name || '',
          m.joined_at ? new Date(m.joined_at).toLocaleDateString() : '',
          activeSub ? 'Paid' : 'Unpaid',
        ]
      })
    ]
    const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n')
    const blob = new Blob([csv], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `mwfc-analytics-${today}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  if (loading) return <LoadingSpinner fullScreen />

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8 flex justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
            Analytics
          </h1>
          <p className="text-gray-500 text-sm">
            Chapter performance, member growth and regional insights
          </p>
        </div>
        <button
          onClick={handleExportCSV}
          disabled={!members.length}
          className="bg-green-600 hover:bg-green-700 disabled:bg-gray-200 dark:disabled:bg-white/5 disabled:text-gray-400 text-white px-4 sm:px-6 py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap"
        >
          Export CSV
        </button>
      </div>
      <ChapterComparison members={members} chapters={chapters} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 mt-4 lg:mt-6">
        <GrowthChart members={members} />
        <RegionBreakdown members={members} />
      </div>
    </AdminLayout>
  )
}